import { OutletState as d } from "@ancon/wildcat-types";
import o from "./isOutletAcceptingPreOrders.mjs";
import { OutletListSection as e } from "./types.mjs";
function f(s) {
  return s.reduce(
    (t, r) => {
      const i = o(
        r.orderFormatSettings
      );
      return r.state === d.Opened ? t[e.OrderNow].push(r) : i ? t[e.PreOrder].push(r) : t[e.Closed].push(r), t;
    },
    {
      [e.OrderNow]: [],
      [e.PreOrder]: [],
      [e.Closed]: []
    }
  );
}
export {
  f as default
};
